"use client";

import React, { useRef } from "react";
import * as motion from "motion/react-client";

import Base from "@/templates/Base";

import CarouselFlex from "@/components/CarouselFlex";

import styles from "./quem-somos.module.scss";

export default function PageClient() {
  const scrollRef = useRef(null);
  const mock = [
    {
      year: "1985",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria1-new.png",
      text: "Cobasi Villa-Lobos, a primeira loja é inaugurada."
    },
    {
      year: "1992",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria2.png",
      text: "Início das importações e introdução de produtos exclusivos."
    },
    {
      year: "1994",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria3.png",
      text: "Transição de loja agropecuária para pet shop."
    },
    {
      year: "1998",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria-new-98.png",
      text: "Início do Cobasi Cuida, pilar da Cobasi que ajuda animais vulneráveis em parceira com ONGs."
    },
    {
      year: "2005",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria4.png",
      text: "Cobasi Campinas Galleria, primeira loja fora da cidade de São Paulo."
    },
    {
      year: "2010",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria5.png",
      text: "Cobasi Barra Carrefour, primeira loja fora do Estado de São Paulo."
    },
    {
      year: "2018",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria6.png",
      text: "Renovação digital com foco em Omnichannel."
    },
    {
      year: "2020",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria7.png",
      text: "Inauguração da Cobasi Eldorado, a centésima loja."
    },
    {
      year: "2021",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria8.png",
      text: "Lançamento de nova marca e aquisição da Pet Anjo."
    },
    {
      year: "2022",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria9.png",
      text: "Primeira empresa do varejo pet a participar do GPTW, conquistando o selo por dois anos consecutivos."
    },
    {
      year: "2022",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria2-new-pet-anjo.png",
      text: "Inauguração da primeira franquia Pet Anjo de Banho e Tosa."
    },
    {
      year: "2023",
      img: "/inst/img/quem-somos/lp-quem-somos-2025-trajetoria10.png",
      text: "Aquisição da Mundo Pet, expandindo para se tornar o maior varejo pet no Nordeste."
    }
  ];

  return (
    <Base>
      <main className={styles.main}>
        <section>
          <div className={styles.banner}>
            <div className={styles.container}>
              <div className={styles.content}>
                <div>
                  <img
                    src="/inst/img/quem-somos/lp-quem-somos-2025-logo-40-anos.png"
                    alt="Logo Cobasi"
                  />
                </div>
                <div>
                  <img
                    className={styles.contentDesk}
                    src="/inst/img/quem-somos/lp-quem-somos-2025-inspire.png"
                    alt="Texto inspire"
                  />
                  <img
                    className={styles.contentMob}
                    src="/inst/img/quem-somos/lp-quem-somos-2025-inspire-mobile.png"
                    alt="Texto inspire"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className={styles.container}>
            <div className={styles.contentAll}>
              <div>
                <h1 className={styles.title}>Cobasi 40 anos</h1>
                <h2>
                  Mediamos afeto, enriquecendo o amor e as conexões entre
                  pessoas, pets e seus lares.
                </h2>
                <p>
                  Há <strong>40 anos cuidamos do lado divertido do lar</strong>,
                  inspirando conexões com a natureza por meio de nossos produtos
                  e serviços.
                </p>
                <p>
                  Temos mais de 240 lojas espalhadas pelo Brasil, onde você
                  encontra mais de 20 mil produtos para pet, casa e jardim,
                  incluindo mais de 500 itens exclusivos de marcas próprias,
                  como MyHug, Flicks, Origem Natural e Joy.
                </p>
                <p>
                  Além disso, oferecemos praticidade e multicanalidade, com
                  serviços disponíveis no site, APP Cobasi, lojas físicas e
                  WhatsApp.
                </p>
              </div>
              <div className={styles.contentVideo}>
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/yrtwXtIlOaY?si=dxQZMeOL9KNFzR8G"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className={styles.container}>
            <div className={styles.bannerSecond}>
              <img
                className={styles.bannerDesk}
                src="/inst/img/quem-somos/lp-quem-somos-2025-banner-second.png"
                alt="Banner Second"
              />
              <img
                className={styles.bannerMob}
                src="/inst/img/quem-somos/lp-quem-somos-2025-banner-second-mobile.png"
                alt="Banner Second"
              />
            </div>
          </div>
        </section>

        <section className={styles.move}>
          <div className={styles.container}>
            <div className={styles.moveTitle}>
              <h3>O que nos move todos os dias:</h3>
            </div>
            <div className={styles.moveContent} ref={scrollRef}>
              <motion.div
                className={styles.moveBox}
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, root: scrollRef }}
                variants={{
                  offscreen: {
                    scale: 0.5,
                    opacity: 0
                  },
                  onscreen: {
                    scale: 1,
                    opacity: 1,
                    transition: {
                      duration: 1
                    }
                  }
                }}
              >
                <img
                  src="/inst/img/quem-somos/lp-quem-somos-2025-240-lojas-new.png"
                  alt="+240 lojas"
                />
                <br />
                <span>+240</span>
                <p>Lojas</p>
              </motion.div>

              <motion.div
                className={styles.moveBox}
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, root: scrollRef }}
                variants={{
                  offscreen: {
                    scale: 0.5,
                    opacity: 0
                  },
                  onscreen: {
                    scale: 1,
                    opacity: 1,
                    transition: {
                      duration: 1,
                      delay: 0.5
                    }
                  }
                }}
              >
                <img
                  className={styles.estados}
                  src="/inst/img/quem-somos/lp-quem-somos-2025-20-estados-new.png"
                  alt="+20 estados e DF"
                />
                <br />
                <span>+20</span>
                <p>Estados e DF</p>
              </motion.div>

              <motion.div
                className={styles.moveBox}
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, root: scrollRef }}
                variants={{
                  offscreen: {
                    scale: 0.5,
                    opacity: 0
                  },
                  onscreen: {
                    scale: 1,
                    opacity: 1,
                    transition: {
                      duration: 1,
                      delay: 1
                    }
                  }
                }}
              >
                <img
                  src="/inst/img/quem-somos/lp-quem-somos-2025-colaboradores-new.png"
                  alt="+7.500 mil colaboradores"
                />
                <br />
                <span>+7.500 MIL</span>
                <p>Colaboradores</p>
              </motion.div>

              <motion.div
                className={styles.moveBox}
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, root: scrollRef }}
                variants={{
                  offscreen: {
                    scale: 0.5,
                    opacity: 0
                  },
                  onscreen: {
                    scale: 1,
                    opacity: 1,
                    transition: {
                      duration: 1,
                      delay: 1.5
                    }
                  }
                }}
              >
                <img
                  src="/inst/img/quem-somos/lp-quem-somos-2025-refeicoes-new.png"
                  alt="+7,4 MILHÕES Refeições doadas"
                />
                <br />
                <span>+7,4 MILHÕES</span>
                <p>Refeições doadas</p>
              </motion.div>
            </div>
          </div>
        </section>

        <section className={styles.trajetoria}>
          <div className={styles.container}>
            <div className={styles.trajetoriaTitle}>
              <img
                src="/inst/img/quem-somos/lp-quem-somos-2025-detail.png"
                alt="Detalhe flor"
              />
              <h3>Conheça nossa trajetória</h3>
              <p>
                Fomos pioneiros no conceito de megaloja voltada especialmente
                para o cuidado de animais de estimação. E com o passar dos anos
                entendemos o vínculo especial que existe entre as relações, seja
                entre pessoas, pets e o lar.
              </p>
            </div>
            <div className={styles.trajetoriaContent}>
              <CarouselFlex
                className="carousel-flex"
                showArrows
                classNameArrow="arrow btn btn-md btn-icon-rounded outlined"
              >
                {mock.map((item, index) => (
                  <div key={index} className={styles.trajetoriaItems}>
                    <img src={item.img} alt={`Cobasi ${item.year}`} />
                    <div className={styles.text}>
                      <h3 className="heading-xs">{item.year}</h3>
                      <p
                        className="body-text-md"
                        style={{ lineHeight: "normal" }}
                      >
                        {item.text}
                      </p>
                    </div>
                  </div>
                ))}
              </CarouselFlex>
            </div>
            <div className={styles.trajetoriaSubContent}>
              <h3>
                Somos um ecossistema que combina propósito, inovação e impacto
                positivo!
              </h3>
            </div>
          </div>
        </section>
      </main>
    </Base>
  );
}
